import { createReducer, on } from '@ngrx/store';
import { SalesProductPrice } from '../../uig-product.models';
import * as UIGProductPriceCalculatorActions from './uig-product-price-calculator.actions';

export const updateProductPriceFeatureKey = 'updateProductPrice';

export const UPDATE_PRODUCT_PRICE = 'updateProductPrice';

export interface UpdateProductPriceState {
    [UPDATE_PRODUCT_PRICE]: {
      updateProductPrice: SalesProductPrice;
      isLoading: boolean;
      error?: Error;
    };
}

export const initialState: UpdateProductPriceState = {
    [UPDATE_PRODUCT_PRICE]: {
      updateProductPrice: null,
      isLoading: false,
      error: null,
    },
};

export const updateProductPriceReducer = createReducer(
    initialState,
    on(UIGProductPriceCalculatorActions.getProductPrice,
        (state) => ({
            ...state,
            [UPDATE_PRODUCT_PRICE]: {
                updateProductPrice: null,
                isLoading: true,
                error: null,
            },
        })),
        on(UIGProductPriceCalculatorActions.getProductPriceSuccess,
            (state,action) => ({
            ...state,
            [UPDATE_PRODUCT_PRICE]: {
                updateProductPrice: action.updateProductPrice,
                isLoading: false,
                error: null,
            },
        })),
        on(UIGProductPriceCalculatorActions.getProductPriceFailure,
        (state) => ({
            ...state,
            [UPDATE_PRODUCT_PRICE]: {
                updateProductPrice: null,
                isLoading: false,
                error: null,
            },
        })),
        // *****************************************************
        on(UIGProductPriceCalculatorActions.updateProductPrice,
        (state) => ({
            ...state,
            [UPDATE_PRODUCT_PRICE]: {
                updateProductPrice: null,
                isLoading: true,
                error: null,
            },
        })),
        on(UIGProductPriceCalculatorActions.updateProductPriceSuccess,
            (state,action) => ({
            ...state,
            [UPDATE_PRODUCT_PRICE]: {
                updateProductPrice: action.updateProductPrice,
                isLoading: false,
                error: null,
            },
        })),
        on(UIGProductPriceCalculatorActions.updateProductPriceFailure,
        (state) => ({
            ...state,
            [UPDATE_PRODUCT_PRICE]: {
                updateProductPrice: null,
                isLoading: false,
                error: null,
            },
        })),
);